module.exports = __webpack_public_path__ + "img/vechainstats-logo.ff52cf4c.png";